/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import React from 'react'; // eslint-disable-line no-unused-vars

import { makeHttpRequest } from './actions';
import { makeAsyncActionSet } from './asyncActions';

export const ITEMS_PER_PAGE = 12;
const WHOLE_COLLECTION_PAGE_SIZE = 10000;

// Collection paths:
export const TENANTS = 'api/tenants';
export const OFFICES = 'api/offices';
export const PASSES = 'api/passes';
export const PASS_TYPES = 'api/passes/types';
export const COURSES = 'api/courses';
export const USERS = 'api/users';
export const USER_ROLES = 'api/users/roles';
export const AUDIT_LOG_ENTRIES = 'api/auditlog';


export const GET_COLLECTION = makeAsyncActionSet('GET_COLLECTION');
export function getCollection(type, opts = {}, collectionName = type) {
  const {
    additionalParams,
    filters,
    method,
  } = opts;

  let {
    shouldAppend,
    searchString,
    page,
    pageSize,
  } = opts;

  shouldAppend = !!shouldAppend;
  page = page || 1;
  pageSize = pageSize || ITEMS_PER_PAGE;
  searchString = searchString || '';

  return makeHttpRequest(
    GET_COLLECTION,
    `/${type}/`,
    method || 'GET',
    Object.assign({}, additionalParams, {
      search: searchString,
      page,
      page_size: pageSize,
    }, filters),
    Object.assign({}, additionalParams, {
      collectionName,
      search: searchString,
      page,
      shouldAppend,
      filters,
    }),
    collectionName,
  );
}

export const ADD_TO_COLLECTION = makeAsyncActionSet('ADD_TO_COLLECTION');
export function addItem(type, data, collectionName = type) {
  return makeHttpRequest(
    ADD_TO_COLLECTION,
    `/${type}/`,
    'POST',
    data,
    { collectionName },
    collectionName,
  );
}

export const DELETE_FROM_COLLECTION = makeAsyncActionSet('DELETE_FROM_COLLECTION');
export function deleteItem(type, id, collectionName = type) {
  return makeHttpRequest(
    DELETE_FROM_COLLECTION,
    `/${type}/${id}/`,
    'DELETE',
    null,
    { collectionName, id },
    collectionName,
  );
}

export function getAllCollection(type, opts0, name) {
  const opts = Object.assign({}, opts0, { pageSize: WHOLE_COLLECTION_PAGE_SIZE });
  return getCollection(type, opts, name);
}

export const CLEAR_COLLECTION = 'CLEAR_COLLECTION';
export function clearCollection(collectionName) {
  return { type: CLEAR_COLLECTION, payload: collectionName };
}

export const RESET_ALL_COLLECTION_PARAMS = 'RESET_ALL_COLLECTION_PARAMS';
export function resetAllCollectionParams() {
  return { type: RESET_ALL_COLLECTION_PARAMS };
}
